/**
 * Simple email formatting check.
 * Does not check complex rules. Use a validation email for that.
 */
export default function isEmail(value: string): boolean {
  // TODO figure out if there's a reason this checks for 3 chars in the username rather than 1
  return /\S\S\S+@\w+/.test(value);
}
